// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__dC6g9","content":"styles_content__S9UB1","checkbox":"styles_checkbox__3OUgW","checkboxLabel":"styles_checkboxLabel__3TrjX"};